module.exports = __webpack_public_path__ + "static/media/icon-brands.3765692e.svg";